import type {AnalysisResult} from '../lib/analysis';
import {evaluateEvidence,type EvidenceLevel} from '../lib/dataQuality';
const status:Record<EvidenceLevel,{name:string;css:string}>={
  observed:{name:'已观测',css:'success'},
  limited:{name:'需复核',css:'partial'},
  estimated:{name:'未经真实数据校准',css:'partial'},
  unavailable:{name:'不可用',css:'error'}
};
export function DataQualityPanel({result}:{result:AnalysisResult|null}){
  if(!result)return null;
  const items=evaluateEvidence(result);
  return <section className="panel" aria-label="数据可信度与来源">
    <div className="panel-title-row">
      <div><h2>数据可信度与来源</h2>
        <p>“已观测”不等于准确无误；“预估”不是平台真实后台数据。该报告尚未宣称经过真实经营数据误差验证。</p></div>
    </div>
    <div className="module-grid">
      {items.map(item=><div className="module-row" key={item.id} title={item.explanation}>
        <span>{item.name}</span>
        <span className={'status-pill status-'+status[item.level].css}>{status[item.level].name}</span>
      </div>)}
    </div>
    <details className="runtime-note"><summary>查看各项数据依据及局限</summary>
      <ul>{items.map(item=><li key={item.id}><strong>{item.name}：</strong>{item.explanation}</li>)}</ul>
    </details>
    <div className="runtime-note">误差校准：真实月度基准库已建立；在取得足够不同品牌的独立回测样本前，不展示虚构的“准确率”。</div>
  </section>;
}
